import { CRM_LIGHTER_TINT_01, BACKGROUND_GRAY_COLOR_NAME, GAINSBORO_COLOR_NAME } from "styles/color-consts";
import colors from "styles/colors";
import { CRM_PRODUCT_ID, DEV_PRODUCT_ID, SERVICE_PRODUCT_ID, WORK_MANAGEMENT_PRODUCT_ID, PLATFORM_PRODUCT_ID } from "constants/products";
export const INT_TO_ID_MAP = {
    product: {
        1: CRM_PRODUCT_ID,
        2: DEV_PRODUCT_ID,
        5: "workCanvas",
        6: "Work_Forms",
        7: WORK_MANAGEMENT_PRODUCT_ID,
        8: SERVICE_PRODUCT_ID,
        9: PLATFORM_PRODUCT_ID
    },
    team: {
        1: "IT",
        0: "HR",
        2: "Marketing",
        9: "Admin_only",
        10: "Finance",
        11: "Engineering",
        12: "Operations",
        13: "Product",
        14: "PMO",
        15: "Company_wide",
        16: "Sales_and_customer_success",
        17: "Creative_and_communications"
    },
    releaseStatus: {
        0: "Beta",
        1: "Live",
        2: "Gradual_release",
        7: "In_the_roadmap"
    },
    plan: {
        2: "Enterprise",
        7: "Basic",
        3: "Standard",
        4: "Pro",
        1: "Free"
    },
    releaseHeighlights: {
        105: true
    }
};
export const COLUMNS_IDS = {
    TITLE: "text",
    SHORT_TEXT: "short_text",
    DATE: "date4",
    DATE_TIME: "date_time",
    PRODUCT: "dropdown",
    TEAM: "team",
    RELEASE_STATUS: "color1",
    PLAN: "color4",
    LOCATION: "dropdown1",
    RELEASE_HIGHLIGHTS: "color0",
    ARTICLE_LINK: "link",
    CLOUDINARY_IMG_URL: "text9",
    READY_TO_POST: "color95",
    MONTHLY_VIDEO_ID: "text85"
};
export const WHATS_NEW_GRAPHQL_COLUMN_IDS = Object.values(COLUMNS_IDS);
const TEAM_BACKGROUND_COLOR = "#FEF8EB";
const PLAN_BACKGROUND_COLOR = "#CCE5FF";
const DEV_PRODUCT_BACKGROUND_COLOR = "#E8F8F0";
const WORK_FORMS_PRODUCT_BACKGROUND_COLOR = "#FFE8E8";
const WORK_MANAGEMENT_PRODUCT_BACKGROUND_COLOR = "#E9E9FF";
const SERVICE_BACKGROUND_COLOR = "#F5EFF1";
export const WHATS_NEW_ITEM_TAG_TEXT_COLOR = "#323338";
export const ID_TO_OPTIONS_NAMES_AND_COLORS = {
    product: {
        data: {
            [WORK_MANAGEMENT_PRODUCT_ID]: {
                name: "monday work management",
                backgroundColor: WORK_MANAGEMENT_PRODUCT_BACKGROUND_COLOR
            },
            [CRM_PRODUCT_ID]: {
                name: "monday CRM",
                backgroundColor: colors[CRM_LIGHTER_TINT_01]
            },
            [DEV_PRODUCT_ID]: {
                name: "monday dev",
                backgroundColor: DEV_PRODUCT_BACKGROUND_COLOR
            },
            [SERVICE_PRODUCT_ID]: {
                name: "monday service",
                backgroundColor: SERVICE_BACKGROUND_COLOR
            },
            workCanvas: {
                name: "WorkCanvas",
                backgroundColor: colors[BACKGROUND_GRAY_COLOR_NAME]
            },
            Work_Forms: {
                name: "WorkForms",
                backgroundColor: WORK_FORMS_PRODUCT_BACKGROUND_COLOR
            },
            [PLATFORM_PRODUCT_ID]: {
                name: "monday platform",
                backgroundColor: colors[GAINSBORO_COLOR_NAME]
            }
        }
    },
    team: {
        data: {
            IT: {
                name: "IT"
            },
            HR: {
                name: "HR"
            },
            Marketing: {
                name: "Marketing"
            },
            Admin_only: {
                name: "Admin only"
            },
            Finance: {
                name: "Finance"
            },
            Engineering: {
                name: "Engineering"
            },
            Operations: {
                name: "Operations"
            },
            Product: {
                name: "Product"
            },
            PMO: {
                name: "PMO"
            },
            Company_wide: {
                name: "Company wide"
            },
            Sales_and_customer_success: {
                name: "Sales & Customer Success"
            },
            Creative_and_communications: {
                name: "Creative & Communications"
            }
        },
        backgroundColor: TEAM_BACKGROUND_COLOR
    },
    releaseStatus: {
        data: {
            Beta: {
                name: "Beta"
            },
            Live: {
                name: "Live"
            },
            Gradual_release: {
                name: "Gradual release"
            },
            In_the_roadmap: {
                name: "In the roadmap"
            }
        }
    },
    plan: {
        data: {
            Enterprise: {
                name: "Enterprise"
            },
            Pro: {
                name: "Pro"
            },
            Standard: {
                name: "Standard"
            },
            Basic: {
                name: "Basic"
            },
            Free: {
                name: "Free"
            }
        },
        // added colors here so it will not brak if we decide to add plan tag
        backgroundColor: PLAN_BACKGROUND_COLOR
    }
};
export const filtersSchema = [
    {
        id: "product",
        title: "Product",
        data: ID_TO_OPTIONS_NAMES_AND_COLORS.product.data
    },
    {
        id: "team",
        title: "Teams",
        data: ID_TO_OPTIONS_NAMES_AND_COLORS.team.data
    },
    {
        id: "plan",
        title: "Plan",
        data: ID_TO_OPTIONS_NAMES_AND_COLORS.plan.data
    }
];
